import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { apply } from ".";
import { getDefaultDecision as _getDefaultDecision, getUserDecision as _getUserDecision } from "..";

/**
 * Main class to manage cookie consents within your application.
 */
var CookieConsentManager = /*#__PURE__*/function () {
  function CookieConsentManager(options) {
    _classCallCheck(this, CookieConsentManager);

    this.options = void 0;
    this.options = options;
  }

  _createClass(CookieConsentManager, [{
    key: "applyCookies",
    value: function applyCookies(options) {
      return apply(_objectSpread(_objectSpread({}, options), this.options));
    }
  }, {
    key: "getUserDecision",
    value: function getUserDecision() {
      return _getUserDecision(this.getOption("decisionCookieName"));
    }
  }, {
    key: "getDefaultDecision",
    value: function getDefaultDecision() {
      var respectLegitimateInterests = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return _getDefaultDecision(this.options, respectLegitimateInterests);
    }
  }, {
    key: "getOption",
    value: function getOption(name) {
      return this.options[name];
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      return this.options;
    }
  }]);

  return CookieConsentManager;
}();

export { CookieConsentManager };